export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: '¿Cómo recibo el material?',
    a: 'Al finalizar la compra recibirás un enlace de descarga inmediata en tu correo electrónico. Accede al instante desde cualquier dispositivo, sin esperas ni envíos físicos.'
  },
  {
    q: '¿Es seguro el pago?',
    a: 'Sí. Utilizamos plataformas de pago certificadas (Stripe, PayPal) con encriptación de 256 bits. Tus datos están 100% protegidos.'
  },
  {
    q: '¿Es un solo pago?',
    a: 'Sí. Es un pago único de 17,99€. No hay suscripción, no hay cuotas mensuales. Compras una sola vez y tienes acceso de por vida.'
  },
  {
    q: '¿Sirve para profesores con poca experiencia?',
    a: 'Absolutamente. El Bono #1 te enseña exactamente por dónde empezar. El sistema está diseñado para ser usado inmediatamente, sin necesidad de experiencia previa.'
  },
  {
    q: '¿Puedo usarlo solo para una etapa concreta?',
    a: 'Sí. Si solo das clases en Primaria, usa los Tomos 1 y 2. Si solo tienes ESO, usa Tomos 3 y 4. Cada tomo es independiente.'
  },
  {
    q: '¿Qué pasa si tengo alumnos de distintos niveles en la misma clase?',
    a: 'Cada sesión incluye una "variante inclusiva" específicamente para eso. Puedes tener el mismo objetivo trabajando a diferentes niveles de dificultad en el mismo ejercicio.'
  },
  {
    q: '¿En qué formato vienen los archivos?',
    a: 'Todo viene en PDF. Compatible con cualquier dispositivo: móvil, tablet, ordenador. Puedes imprimir o consultar digitalmente.'
  },
  {
    q: '¿Tiene garantía de devolución?',
    a: 'Sí. 7 días de garantía. Si el producto no cumple con lo prometido, escríbenos a manualeslistos@gmail.com y revisamos tu caso en menos de 24 horas.'
  }
];
